<script setup lang="ts">
interface Props {
  count?: number
  hideOrganizationDetails?: boolean
}

const props = withDefaults(defineProps<Props>(), {
  count: 10,
  hideOrganizationDetails: false
})
</script>

<template>
  <div class="space-y-2">
    <div
      v-for="n in props.count"
      :key="n"
      class="grid animate-pulse grid-cols-2 rounded-md bg-white p-4 shadow-sm"
    >
      <div class="flex">
        <div
          v-if="!props.hideOrganizationDetails"
          class="h-16 w-16 shrink-0 rounded-md bg-gray-300"
        />
        <div class="ml-4 flex flex-grow flex-col">
          <div class="h-6 w-40 rounded-md bg-gray-300" />
          <div class="mt-1 h-4 w-60 rounded-md bg-gray-300" />
        </div>
      </div>
      <div class="grid grid-cols-2">
        <div>
          <div class="h-3 w-16 rounded-md bg-gray-300" />
          <div class="mt-0.5 h-4 w-20 rounded-md bg-gray-300" />
        </div>
        <div>
          <div class="h-3 w-16 rounded-md bg-gray-300" />
          <div class="mt-0.5 h-4 w-20 rounded-md bg-gray-300" />
        </div>
      </div>
    </div>
  </div>
</template>
